/* perf 30.09 D-10: skrypt sekcji „Zawartość zestawu” przeniesiony z inline sections/zawartosc-zestawu.liquid
   (6 KB HTML na każdej karcie) do pliku z defer. Logika bez zmian (z poprawką A-01), bez logów console.log.
   Dane sekcji z atrybutów <section data-sv-zestaw data-section-id data-variant-mappings>; każda sekcja startuje raz. */
(function () {
  // perf 30.09 (R2-04): wspólny rejestr dla wszystkich wykonań pliku - dwie instancje sekcji = dwa <script src>, każdy korzeń startuje raz
  const started = window.__svZestawStarted || (window.__svZestawStarted = new WeakSet());

  function initZestaw(root) {
    if (started.has(root)) return;
    started.add(root);
    const sectionId = root.getAttribute('data-section-id');
    const section = document.getElementById('shopify-section-' + sectionId) || root;
    
    // Pobieranie mapowania wariantów
    const variantMappings = root.getAttribute('data-variant-mappings') || '';
    let mappingsArray = [];
    try {
      mappingsArray = JSON.parse(variantMappings);
    } catch (e) {
      console.error('Error parsing variant mappings:', e);
      mappingsArray = ["Czarny", "Biały", "Srebrny"];
    }
    
    // Funkcja do aktualizacji obrazów na podstawie wybranego wariantu
    function updateImagesForVariant(selectedValue) {
      
      // Znajdujemy indeks wariantu
      let variantIndex = 1;
      const normalizedValue = selectedValue.toLowerCase().trim();
      
      for (let i = 0; i < mappingsArray.length; i++) {
        if (mappingsArray[i].toLowerCase() === normalizedValue) {
          variantIndex = i + 1;
          break;
        }
      }
      
      
      const images = section.querySelectorAll('.variant-dependent-image');
      
      images.forEach(img => {
        img.classList.add('switching');
        
        setTimeout(() => {
          const newSrc = img.getAttribute('data-variant-' + variantIndex);
          
          if (newSrc && newSrc !== '') {
            img.src = newSrc;
          }
          img.classList.remove('switching');
        }, 300);
      });
    }
  
    // Znajdowanie inputów wariantów
    function findVariantInputs() {
      // Szukamy inputów radio dla wariantów
      /* SkinVibe 26.09: radia tylko z wyboru wariantu karty - koszyk (karty bestsellerow) ma wlasne zaznaczone radia xs-color, ktore wczesniej byly czytane jako kolor produktu */
      let inputs = (document.querySelector('variant-selects, variant-radios') || document).querySelectorAll('input[type="radio"]');
      
      // Filtrujemy tylko te, które dotyczą kolorów
      let colorInputs = [];
      inputs.forEach(input => {
        // Sprawdzamy różne możliwe sposoby identyfikacji inputów kolorów
        if (input.name && (
            input.name.toLowerCase().includes('color') ||
            input.name.toLowerCase().includes('kolor') ||
            input.name.includes('option1') || // Dawn theme
            input.name.includes('option-0') || // Niektóre motywy
            input.closest('fieldset')?.querySelector('legend')?.textContent.toLowerCase().includes('olor')
        )) {
          colorInputs.push(input);
        }
      });
      
      return colorInputs.length > 0 ? colorInputs : inputs;
    }
  
    // Nasłuchiwanie na zmiany w inputach wariantów
    /* perf 30.09 A-01: nasluch delegowany na stalym <product-info>. variant-selects jest podmieniany po kazdej
       zmianie wariantu (product-info.js -> HTMLUpdateUtility.viewTransition), wiec nasluch przypiety do radia dzialal tylko
       przy pierwszej zmianie koloru (lab 30.09: po 2. i 3. zmianie zdjecia zestawu zostawaly w poprzednim kolorze). */
    const trackedNames = new Set(Array.from(findVariantInputs()).map(input => input.name));
    const variantRoot = document.querySelector('product-info[id^="MainProduct-"]') || document;

    variantRoot.addEventListener('change', function(event) {
      const input = event.target;
      if (!input || !input.closest || !input.closest('variant-selects, variant-radios')) return;
      if (input.type === 'radio' && !trackedNames.has(input.name)) return;
      updateImagesForVariant(input.value);
    });
    
    // Nasłuchujemy również na zmiany wariantów przez Shopify
    document.addEventListener('variant:change', function(event) {
      /* SkinVibe 26.09: JSON wariantu nie ma pola product - ta sciezka to tylko zapas; zdjecia i dane zmienia nasluch 'change' */
      if (event.detail && event.detail.variant && event.detail.variant.product) {
        // Szukamy opcji koloru w wariancie
        const colorOption = event.detail.variant.options.find((option, index) => {
          const optionName = event.detail.variant.product.options[index];
          return optionName && (
            optionName.toLowerCase().includes('color') ||
            optionName.toLowerCase().includes('kolor')
          );
        });
        
        if (colorOption) {
          updateImagesForVariant(colorOption);
        }
      }
    });
  
    // Inicjalizacja przy załadowaniu strony
    setTimeout(() => {
      const checkedInput = (document.querySelector('variant-selects, variant-radios') || document).querySelector('input[type="radio"]:checked');
      const selectedOption = document.querySelector('select option:checked');
      
      if (checkedInput) {
        const selectedValue = checkedInput.value;
        updateImagesForVariant(selectedValue);
      } else if (selectedOption) {
        const selectedValue = selectedOption.value;
        updateImagesForVariant(selectedValue);
      }
    }, 100);
  
    // Obsługa przycisków "Dowiedz się więcej"
    section.querySelectorAll('.zestaw-toggle').forEach(button => {
      button.addEventListener('click', (e) => {
        const content = button.closest('.zestaw-content');
        const description = content.querySelector('.zestaw-description');
        const arrow = button.querySelector('.toggle-arrow');
        
        // Zamykamy inne opisy
        section.querySelectorAll('.zestaw-description').forEach(desc => {
          if (desc !== description) {
            desc.classList.remove('active');
          }
        });
        
        section.querySelectorAll('.toggle-arrow').forEach(arr => {
          if (arr !== arrow) {
            arr.classList.remove('active');
          }
        });
        
        description.classList.toggle('active');
        arrow.classList.toggle('active');
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-sv-zestaw]').forEach(initZestaw);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
